<template>
  <div class="container-fluid">
    <template v-if="fromDetailView">
      <detail-view-content-element-header
        :content-element="headerComponent"
        :object-model-entry="selectedObjectModelEntry"
        :hide-tabs="true"
      ></detail-view-content-element-header>
      <div class="container">
        <br>
        <h2>{{embeddedListViewTitle}}</h2>
        <hr>
      </div>
    </template>
    <div v-else class="container">
      <br>
      <h2>{{targetListView.titleOrDefault}}</h2>
      <hr>
    </div>
    <div v-if="showDescription" class="container" id="short-description">
      <div v-html="targetListView.short_description" class="fr-view"></div>
      <hr>
    </div>
    <div class="module-alt">
      <flash></flash>
      <list-view-table
        v-if="targetListView"
        :list-view="targetListView"
        :preview="preview"
        :opts="tableOpts"
      ></list-view-table>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import ListViewTable from "./list-view-table.vue";
  import Flash from "~/components/flash/flash.vue";
  import ListView from "../../../common/models/listViews/listView";
  import PublishedListView from "../../../common/models/listViews/publishedListView";
  import DetailViewContentElementHeader from "./detail-view-content-element-header.vue";
  import DetailViewContentElement from "~/models/detailView/elements/detailViewContentElement";
  import {DetailViewContentElementType} from "~/enums/detailViews/detailViewContentElementType";
  import dashboardDrilldownFiltersMixin from "../mixins/dashboardDrilldownFiltersMixin";

  export default Vue.extend({
    mixins: [dashboardDrilldownFiltersMixin],
    components: {
      DetailViewContentElementHeader,
      ListViewTable,
      Flash,
    },
    props: {
      preview: {
        type: Boolean,
        default: false,
      },
    },
    beforeMount() {
      if (["list_view_id", "detail_view_id"].every(el => Object.keys(this.$route.params).includes(el) )) {
        this.$store.dispatch('detailViewStore/fetchAssociatedListView', {
          organizationId: this.selectedOrganization.id,
          detailViewId: this.$route.params.detail_view_id,
          listViewId: this.$route.params.list_view_id
        }).then(listView => {
          this.$store.dispatch('detailViewStore/setListViewForPreview', {listView})
        })
      }
      // handle SEO config
      if (this.isOneStop) {
        // keywords
        if (this.targetListView.seo_keywords.length > 0) {
          let metaKeywords = document.querySelector('meta[name="keywords"]')
          let newKeywords = metaKeywords.getAttribute("content") + ", " + this.targetListView.seo_keywords.join(", ")
          metaKeywords.setAttribute("content", newKeywords);
        }

        // description
        if (this.targetListView.seo_meta_description) {
          let metaDescription = document.querySelector('meta[name="description"]')
          metaDescription.setAttribute("content", this.targetListView.seo_meta_description)
        }

        // title
        if (this.targetListView.seo_title) {
          let pageTitle = document.title.split("|")
          pageTitle[0] = this.targetListView.seo_title
          document.title = pageTitle.join(" | ")
        }
      }
    },
    computed: {
      targetListView(): ListView | PublishedListView {
        if (this.preview) {
          return this.$store.state.detailViewStore.listViewForPreview || this.selectedListView;
        } else {
          return this.selectedPublishedListView;
        }
      },
      fromDetailView(): boolean {
        if (this.preview) return

        const query = this.$router.currentRoute.query
        return query['detailViewId'] && query['parentEntryId'] && query['relationId']
      },
      headerComponent(): DetailViewContentElement {
        return this.selectedDetailView.contentElementsArray.filter(fe => fe.content_type === DetailViewContentElementType.Header)[0];
      },
      embeddedListViewTitle(): string {
        return this.selectedDetailView.embeddedListViewTitle
      },
      tableOpts() {
        return {
          showConnectedText: this.fromDetailView
        }
      },
      showDescription(): boolean {
        return this.targetListView.show_description && !!this.targetListView.short_description;
      },
    },
  });
</script>